// extracted by mini-css-extract-plugin
export var registerButtonOverride = "components-banners-__RegisterForAccount-module___registerButtonOverride";
export var widthFull = "components-banners-__RegisterForAccount-module___widthFull";